import styled from 'styled-components';
import { motion, Variants } from 'framer-motion';
import { space, SpaceProps, color, ColorProps, border, BorderProps, layout, LayoutProps } from 'styled-system';
import Box from '../box/box';

interface CollapseProps extends SpaceProps, ColorProps, BorderProps, LayoutProps {}

const variants: Variants = {
	hidden: { opacity: 0, y: '-10px', transitionEnd: { display: 'none' } },
	visible: { opacity: 1, y: 0, scale: 1, display: 'block' }
};

const variantsRotate: Variants = {
	down: { rotate: '0deg', y: ['0px', '-2px', '2px', '0px'] },
	up: { rotate: '180deg', y: ['0px', '2px', '-2px', '0px'] }
};

// interface ExtendedSpaceProps extends SpaceProps {
// 	backgroundColor: string;
// }

const Wrapper = styled.div<CollapseProps>`
	position: relative;
	.icon--sprite {
		fill: var(--collapse-view-chevron, currentColor);
	}
	${space}
	${color}
	${border}
	${layout}
`;

Wrapper.defaultProps = {
	p: 6,
	mt: 0,
	mb: 2,
	bg: 'var(--link-list, rgba(var(--base-10), 1))',
	borderRadius: '3px'
};

// const MotionIconWrapper = motion(props => <CustomSpan {...props} />);

const MotionIconWrapper = styled(motion.span)<{ height?: number; width?: number }>`
	height: ${({ height }) => `${height || 24}px`};
	width: ${({ width }) => `${width || 24}px`};
`;

const Flex = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	cursor: pointer;
`;

const ContentWrapper = motion(Box);

ContentWrapper.defaultProps = {
	bg: 'var(--link-list, rgba(var(--base-10), 1))'
};

export { variants, variantsRotate, Wrapper, MotionIconWrapper, Flex, ContentWrapper };

// import styled from 'styled-components';
// import { motion, Variants } from 'framer-motion';
// import { space, SpaceProps } from 'styled-system';
// import Box from '../box/box';

// const variants: Variants = {
// 	hidden: { opacity: 0, y: '-10px', transitionEnd: { display: 'none' } },
// 	visible: { opacity: 1, y: 0, scale: 1, display: 'block' }
// };

// const variantsRotate: Variants = {
// 	down: { rotate: '0deg', y: ['0px', '-2px', '2px', '0px'] },
// 	up: { rotate: '180deg', y: ['0px', '2px', '-2px', '0px'] }
// };

// interface ExtendedSpaceProps extends SpaceProps {
// 	backgroundColor: string;
// }

// const Wrapper = styled.div<ExtendedSpaceProps>`
// 	border-radius: 3px;
// 	background-color: ${props =>
// 		props.backgroundColor ? props.backgroundColor : 'var(--link-list, rgba(var(--base-10), 1))'};
// 	.icon--sprite {
// 		fill: var(--collapse-view-chevron, currentColor);
// 	}
// 	${space}
// `;

// Wrapper.defaultProps = {
// 	p: 6,
// 	mt: 0,
// 	mb: 2
// };

// // const MotionIconWrapper = motion(props => <CustomSpan {...props} />);

// const MotionIconWrapper = styled(motion.span)`
// 	width: 24px;
// 	height: 24px;
// `;

// const Flex = styled.div`
// 	display: flex;
// 	justify-content: space-between;
// 	align-items: center;
// 	cursor: pointer;
// 	p {
// 		font: var(--collapse-title-font-weight, var(--label-regular));
// 	}
// `;

// const ContentWrapper = motion(Box);

// export { variants, variantsRotate, Wrapper, MotionIconWrapper, Flex, ContentWrapper };
